// API Configuration
export const API_CONFIG = {
  // Base URL for the API
  BASE_URL: process.env.REACT_APP_API_URL || 'http://localhost:3003',

  // API Endpoints
  ENDPOINTS: {
    AUTH: {
      LOGIN: '/auth/login',
      LOGOUT: '/auth/logout',
      VALIDATE: '/auth/validate',
      RESET_PASSWORD: '/auth/reset-password',
      UPDATE_PASSWORD: '/auth/update-password',
    },
    USERS: {
      BASE: '/users',
      BY_ID: (id: number) => `/users/${id}`,
    },
    INVENTORY_ITEMS: {
      BASE: '/inventory-items',
      BY_ID: (id: number) => `/inventory-items/${id}`,
      LOOKUP: (upc: string) => `/inventory-items/lookup/${encodeURIComponent(upc)}`,
    },
    INVENTORY_VENDORS: {
      BASE: '/inventory-vendors',
      BY_ID: (id: number) => `/inventory-vendors/${id}`,
    },
  },

  // Request Configuration
  DEFAULT_HEADERS: {
    'Content-Type': 'application/json',
  },

  // Timeout settings
  TIMEOUT: 10000, // 10 seconds
};

// Helper function to build full API URLs
export const buildApiUrl = (endpoint: string): string => {
  return `${API_CONFIG.BASE_URL}${endpoint}`;
};

// Helper function to get auth headers
export const getAuthHeaders = (token: string) => ({
  ...API_CONFIG.DEFAULT_HEADERS,
  'Authorization': `Bearer ${token}`,
});

// Helper function to get default headers
export const getDefaultHeaders = () => API_CONFIG.DEFAULT_HEADERS;
